import { makeStyles, createStyles, alpha } from '@material-ui/core/styles';
import type { Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
    const backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[600];
    const color = theme.palette.type === 'light' ? theme.palette.grey[600] : theme.palette.grey[300];

    return createStyles({
        root: {
            alignItems: 'center',
            backgroundColor,
            border: 'none',
            borderRadius: 32,
            boxSizing: 'border-box',
            color,
            display: 'inline-flex',
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(16),
            fontWeight: theme.typography.fontWeightMedium as number,
            minHeight: 32,
            outline: 0,
            textDecoration: 'none',
            whiteSpace: 'nowrap',
            '&$disabled': {
                opacity: 0.5,
                pointerEvents: 'none',
            },
        },
        label: {
            overflow: 'hidden',
            paddingLeft: 16,
            paddingRight: 16,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
        startIcon: {
            fontSize: theme.typography.pxToRem(20),
            marginLeft: 8,
            marginRight: -8,
        },
        endIcon: {
            fontSize: theme.typography.pxToRem(20),
            marginLeft: -8,
            marginRight: 8,
        },
        sizeSmall: {
            fontSize: theme.typography.pxToRem(14),
            minHeight: 24,
        },
        shapeRounded: {
            borderRadius: 9,
        },
        filled: {},
        outlined: {
            backgroundColor: 'transparent',
            border: `1px solid ${backgroundColor}`,
        },
        standard: {
            backgroundColor: alpha(theme.palette.grey[500], 0.1),
        },
        filledPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
        },
        filledSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
        },
        filledSuccess: {
            color: theme.palette.success.contrastText,
            backgroundColor: theme.palette.success.main,
        },
        filledInfo: {
            color: theme.palette.info.contrastText,
            backgroundColor: theme.palette.info.main,
        },
        filledWarning: {
            color: theme.palette.warning.contrastText,
            backgroundColor: theme.palette.warning.main,
        },
        filledError: {
            color: theme.palette.error.contrastText,
            backgroundColor: theme.palette.error.main,
        },
        outlinedPrimary: {
            color: theme.palette.primary.main,
            border: `1px solid ${theme.palette.primary.main}`,
            backgroundColor: 'transparent',
        },
        outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: `1px solid ${theme.palette.secondary.main}`,
            backgroundColor: 'transparent',
        },
        outlinedSuccess: {
            color: theme.palette.success.main,
            border: `1px solid ${theme.palette.success.main}`,
            backgroundColor: 'transparent',
        },
        outlinedInfo: {
            color: theme.palette.info.main,
            border: `1px solid ${theme.palette.info.main}`,
            backgroundColor: 'transparent',
        },
        outlinedWarning: {
            color: theme.palette.warning.main,
            border: `1px solid ${theme.palette.warning.main}`,
            backgroundColor: 'transparent',
        },
        outlinedError: {
            color: theme.palette.error.main,
            border: `1px solid ${theme.palette.error.main}`,
            backgroundColor: 'transparent',
        },
        standardPrimary: {
            color: theme.palette.primary.dark,
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
        },
        standardSecondary: {
            color: theme.palette.secondary.dark,
            backgroundColor: alpha(theme.palette.secondary.main, 0.1),
        },
        standardSuccess: {
            color: theme.palette.success.dark,
            backgroundColor: alpha(theme.palette.success.main, 0.1),
        },
        standardInfo: {
            color: theme.palette.info.dark,
            backgroundColor: alpha(theme.palette.info.main, 0.1),
        },
        standardWarning: {
            color: theme.palette.warning.dark,
            backgroundColor: alpha(theme.palette.warning.main, 0.1),
        },
        standardError: {
            color: theme.palette.error.dark,
            backgroundColor: alpha(theme.palette.error.main, 0.1),
        },
        disabled: {},
    });
};

export default makeStyles(styles, { name: 'MuiPill' });
